import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/store/Logo";
import { Starfield } from "@/components/store/Starfield";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#07090e] px-4">
      <Starfield className="opacity-60" />
      <div className="absolute left-6 top-6"><Logo /></div>
      <div className="relative text-center">
        <XCircle className="mx-auto h-14 w-14 text-slate-500" />
        <h1 className="font-display mt-6 text-3xl font-extrabold text-white">Payment canceled.</h1>
        <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-slate-400">
          No charge was made. Your 44% launch discount is still active whenever you're ready.
        </p>
        <Link to="/" data-testid="cancel-home-link" className="mt-8 inline-block rounded-full bg-cyan-400 px-8 py-3.5 text-sm font-bold text-[#07090e] transition-transform hover:scale-105 active:scale-95">
          Return to the Store
        </Link>
      </div>
    </div>
  );
}
